import { createContext } from 'react';

import { type SelectedRoleContext, type UserContext } from './types';

export const UserContextObj = createContext<undefined | UserContext>(undefined);

export const SelectedRoleContextObj = createContext<SelectedRoleContext | undefined>(undefined);
